import api from './api';

export const getInboxThreads = (params = {}) => api.get('/inbox', { params });
export const getInboxFolders = () => api.get('/inbox/folders');
export const createInboxFolder = (name) => api.post('/inbox/folders', { name });
export const deleteInboxFolder = (folderKey) => api.delete(`/inbox/folders/${encodeURIComponent(folderKey)}`);
export const getInboxMessages = (threadId, params = {}) => api.get(`/inbox/${threadId}/messages`, { params });
export const sendInboxMessage = (threadId, data) => api.post(`/inbox/${threadId}/messages`, data);
export const markInboxRead = (threadId) => api.post(`/inbox/${threadId}/read`);
export const composeInboxMail = (data) => api.post('/inbox/compose', data);
export const deleteInboxMessage = (messageId) => api.delete(`/inbox/messages/${messageId}`);
export const moveInboxThreadToFolder = (threadId, folder) => api.patch(`/inbox/${threadId}/folder`, { folder });
export const reorderInboxFolder = (folder, threadIds) => api.patch(`/inbox/folder/${folder}/order`, { threadIds });
export const deleteInboxThread = (threadId) => api.delete(`/inbox/${threadId}`);
export const emptyInboxTrash = () => api.post('/inbox/trash/empty');
